'use strict';
(function($){
    /*
     * Vetology.Recaptcha widget
     *
     * @description A wrapper for the google recaptcha component
     *
     * @options					See description for each option
     *
     * @method	See description above each method
     */
    $.widget(
        'Vetology.recaptcha',
        {
            options: {
                site_key: ""
            },
            /*
             * Vetology.Vetology._create
             *
             * @description Vetology.Recaptcha constructor
             *
             * @return NULL
             *
             */
            "_create": function(){
                var o = this;
                if(o.options.site_key !==""){
                    o._recaptcha_element = $('<div class="g-recaptcha" data-sitekey="' + o.options.site_key + '" data-callback="recaptchaCallback"></div>');
                    $(o.element).append(o._recaptcha_element);
                }
                else {
                    o.error_element = $('<div><span>Cannot show the captcha widget: the site-key is empty.</span></div>');
                    $(o.element).append(o.error_element);
                }
            },
            /*
             * Vetology.Vetology._init
             *
             * @description	Initializes the Vetology.Recaptcha
             *
             * @return NULL
             *
             */
            "_init": function(){
                var o = this;
            }
        }
    );
})(jQuery);

function recaptchaCallback(){
    if($("#recaptcha_contact_us").hasClass("has-captcha-error"))
        $("#recaptcha_contact_us").removeClass("has-captcha-error");
}